import React, { useEffect, useState } from "react";
import "./student-dashboard.css";
import { useNavigate } from "react-router-dom";
import ASSETS from "../../../../app/config/assets";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../../ui/atoms/buttons/Button";
import BackgroundPaths from "../../../../ui/molecules/background-paths/BackgroundPaths";
import RadarChart from "../../../../ui/molecules/radar-chart/RadarChart";
import GaugeChart from "../../../../ui/molecules/gauge-chart/GaugeChart";
import CircularProgressBar from "../../components/circular-progress-bar/CircularProgressBar";
import Loading from "../../../../ui/atoms/loading/Loading";
//
import {
  capitalize,
  capitalizeAll,
  isEmpty,
  wait,
} from "../../../../core/utils/helpers";
import { useSelector } from "react-redux";
import { onGetStudentDashboard } from "../../../admin/services/user";
import {
  onJoiningAssessment,
  onProcessAssessmentInvitation,
} from "../../services/course";
import moment from "moment";
import Swal from "sweetalert2";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import { useDispatch } from "react-redux";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const chartData = [
  {
    label: "Assessment",
    values: [8, 7, 9, 6, 8, 7], // <- ADDED DATA HERE
  },
  {
    label: "Quiz",
    values: [5, 6, 8, 7, 9, 5], // <- ADDED DATA HERE
  },
];
const chartVariables = [
  { key: "resilience", label: "Resilience" },
  { key: "strength", label: "Strength" },
  { key: "adaptability", label: "Adaptability" },
  { key: "creativity", label: "Creativity" },
  { key: "openness", label: "Openness" },
  { key: "confidence", label: "Confidence" },
];

const StudentDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();

  const [isLoading, setIsLoading] = useState(true);

  const [isToggleChallenge, setIsToggleChallenge] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [assessmentCode, setAssessmentCode] = useState("");
  const [dashboardData, setDashboardData] = useState({});

  const userInformations = useSelector(
    (state) => state.setInitConf.userInformations,
  );

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  const _sys_role = currentConnectedStream?.sys_role;
  const _inscription_id = currentConnectedStream?.inscription_id;
  const _school_title = currentConnectedStream?.school_title;
  const _stream_title = currentConnectedStream?.stream_title;
  const _stream_id = currentConnectedStream?.stream_id;

  const onToggleChallenge = () => {
    setIsToggleChallenge(!isToggleChallenge);
  };

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const localData = {
        inscription_id: _inscription_id,
        stream_id: _stream_id,
      };

      onGetStudentDashboard(axiosPrivate, localData, signal).then(
        (response) => {
          const _data = response?.data?.result;
          setDashboardData(_data);
        },
      );
      setIsLoading(false);

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };

    if (!isEmpty(currentConnectedStream?.stream_id)) fetchData();
  }, [isRefresh, currentConnectedStream]);

  const onHandleJoiningAssessment = async () => {
    setIsSending(true);
    await wait(500);
    //
    const localData = {
      inscription_id: _inscription_id,
      assessment_code: assessmentCode,
      request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    onJoiningAssessment(axiosPrivate, localData)
      .then((response) => {
        const _data = response?.data;
        const _status = _data?.status;
        if (_status) {
          const _assessment_mode = _data?.assessment_mode;
          const _assessment_id = _data?.assessment_id;
          const _assessment_invitation_id = _data?.assessment_invitation_id;

          dispatch(
            challengeSlice?.actions?.setLessonAssessment({
              assessment_type: "LA", // LA stand for Lesson Assessment
              assessment_mode: _assessment_mode,
              assessment_id: _assessment_id,
              assessment_invitation_id: _assessment_invitation_id,
            }),
          );

          const _to = `/${_sys_role}/lessons/assessment`;
          navigate(_to, { replace: true });
        } else {
          Swal.fire({
            icon: "info",
            title: "Request Joining Challenge",
            text: _data?.message,
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "[SDASH][onJoiningAssessment]:Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "[SDASH][onJoiningAssessment]:Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });
  };

  const onHandleProcessAssessmentInvitation = async (
    invitation_id,
    response_status,
  ) => {
    setIsSending(true);
    await wait(500);
    //
    const localData = {
      inscription_id: _inscription_id,
      invitation_id: invitation_id,
      status: response_status,
      response_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    onProcessAssessmentInvitation(axiosPrivate, localData)
      .then((response) => {
        setIsSending(false);
        const _data = response?.data;
        const _status = _data?.status;
        if (_status) {
          setIsRefresh((prev) => !prev);
        } else {
          Swal.fire({
            icon: "info",
            title: "Request Joining Challenge",
            text: _data?.message,
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "[SDASH][onProcessAssessmentInvitation]:Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "[SDASH][onProcessAssessmentInvitation]:Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading type={"type-2"} />
      ) : (
        <div className="w-full h-full student-dashboard">
          <div className="w-full section-banner">
            <div className="s-b-inner">
              <BackgroundPaths />
            </div>
            <div className="s-b-outer">
              <div className="s-b-outer-description">
                <h1>
                  School of {capitalizeAll(_school_title)} :{" "}
                  {capitalizeAll(_stream_title)}
                </h1>
                <h2>
                  <span className="mr-xs">👋🏼</span>Hey{" "}
                  {capitalize(userInformations?.firstname)}, Welcome In...
                </h2>
                <p className="subscription-text">
                  <strong>
                    Your subscription is about to expire on{" "}
                    {moment(dashboardData?.end_subscription).format(
                      "MMMM Do YYYY, h:mm:ss a",
                    )}
                  </strong>
                </p>
                <p>
                  Your last activity held on{" "}
                  {moment(dashboardData?.before_last_login).fromNow()} (
                  {moment(dashboardData?.before_last_login).format(
                    "MMMM Do YYYY, h:mm:ss a",
                  )}
                  )
                </p>
              </div>
              {!isEmpty(dashboardData?.my_invitations) && (
                <div className="s-b-outer-assessment-invitations">
                  <div className="a-i-head">
                    <h3>♻️ Assessment Invitations</h3>
                  </div>
                  <div className="a-i-body">
                    {dashboardData?.my_invitations?.map((invitation, idx) => {
                      return (
                        <div className="a-i-body-item" key={idx}>
                          <div className="a-i-body-item-content">
                            <img
                              src={ASSETS?.icon_letter_gif}
                              alt="Invitation Letter Icon"
                            />
                            <div>
                              <span>Invitation from</span>
                              <h2>{`${capitalizeAll(invitation?.firstname)} ${capitalizeAll(invitation?.lastname)}`}</h2>
                              <span>
                                {moment(invitation?.invitation_dates).fromNow()}
                              </span>
                            </div>
                          </div>
                          {isSending ? (
                            <img
                              src={ASSETS?.icon_loading_gif}
                              alt="invitation processing..."
                            />
                          ) : (
                            <div className="a-i-body-item-actions">
                              {invitation?.invitation_status === "sent" && (
                                <React.Fragment>
                                  <div className="w-fit-content">
                                    <Button
                                      title={"Decline"}
                                      type={"button"}
                                      preferedStyle={"danger"}
                                      action={() =>
                                        onHandleProcessAssessmentInvitation(
                                          invitation?.invitation_id,
                                          "declined",
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="w-fit-content">
                                    <Button
                                      title={"Accept"}
                                      type={"button"}
                                      preferedStyle={"validate"}
                                      action={() =>
                                        onHandleProcessAssessmentInvitation(
                                          invitation?.invitation_id,
                                          "accepted",
                                        )
                                      }
                                    />
                                  </div>
                                </React.Fragment>
                              )}
                              {invitation?.invitation_status === "accepted" && (
                                <div className="w-fit-content">
                                  <Button
                                    title={"✅ Accepted, Click to Join"}
                                    type={"button"}
                                    preferedStyle={"normal"}
                                    action={() => {
                                      dispatch(
                                        challengeSlice?.actions?.setLessonAssessment(
                                          {
                                            assessment_type: "LA", // LA stand for Lesson Assessment
                                            assessment_mode:
                                              invitation?.assessment_mode,
                                            assessment_id:
                                              invitation?.assessment_id,
                                            assessment_invitation_id:
                                              invitation?.invitation_id,
                                          },
                                        ),
                                      );

                                      const _to = `/${_sys_role}/lessons/assessment`;
                                      navigate(_to, { replace: true });
                                    }}
                                  />
                                </div>
                              )}
                              {invitation?.invitation_status === "declined" && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "1rem",
                                    fontStyle: "italic",
                                  }}
                                >
                                  ❌ Declined
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="s-b-outer-assessment">
                <Button
                  title={"#️⃣ Click to Join Assessment"}
                  type={"button"}
                  preferedStyle={"normal"}
                  action={() => onToggleChallenge()}
                />
                {!isEmpty(dashboardData?.my_last_assessment_created_code) && (
                  <React.Fragment>
                    <span>Your last created assessment's Code :</span>
                    <h1>{dashboardData?.my_last_assessment_created_code}</h1>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <div className="w-full section">
            <h1>Learning Global Assessment</h1>
            <div className="section-wrapper">
              <div className="s-w-item-chart">
                <h2 className="mb-xs">Skill Assessment</h2>
                <RadarChart
                  // data={chartData}
                  // variables={chartVariables}
                  data={dashboardData?.skills?.chart_data || []}
                  variables={dashboardData?.skills?.chart_variables || []}
                  width={420}
                  height={420}
                  maxValue={10} // Max value for the domain (scores are 0-10)
                />
              </div>
              <div className="s-w-item-progress">
                <div className="progress-item">
                  <h2>Learning Global Progression</h2>
                  <p className="mb-xs">
                    This is about every lesson read so far relative to all
                    lessons.
                  </p>
                  <div className="progress-wrapper">
                    <CircularProgressBar
                      value={dashboardData?.global_learning_progress}
                    />
                  </div>
                </div>
                {/* <div className="progress-item">
              <h2>Assessment Grobal Progression</h2>
              <p className="mb-xs">
                This is about different assessment got from lesson to lesson.
              </p>
              <div className="progress-wrapper">
                <CircularProgressBar
                  value={dashboardData?.global_assessment_progress}
                />
              </div>
            </div> */}
                <div className="progress-item">
                  <h2>Assessment Global Progression</h2>
                  <p className="mb-xs">
                    This is about different assessment got from lesson to
                    lesson.
                  </p>
                  <div className="progress-wrapper">
                    <GaugeChart
                      value={dashboardData?.global_assessment_progress / 100}
                    />
                  </div>
                </div>
              </div>
              <div className="s-w-item-courses">
                <h2>Courses Overview</h2>
                <p className="mb-xs">
                  This is about the learning progress of every course.
                </p>
                <div className="course-wrapper">
                  {isEmpty(dashboardData?.progress_result) ? (
                    <p></p>
                  ) : (
                    dashboardData?.progress_result?.map((row, idx) => {
                      return (
                        <div className="course-row" key={idx}>
                          <h3>{capitalizeAll(row?.course_title)}</h3>
                          <div className="c-col">
                            <span>Learning Progress</span>
                            <p>{row?.learning_percent}%</p>
                          </div>
                          <div
                            className={
                              row?.quiz_points_won >
                              row?.total_quiz_max_points / 2
                                ? "c-col green"
                                : "c-col red"
                            }
                          >
                            <span>Quiz Note</span>
                            <p>{row?.quiz_mark}</p>
                          </div>
                          <div
                            className={
                              row?.assessment_points_won >
                              row?.total_assessment_max_points / 2
                                ? "c-col green"
                                : "c-col red"
                            }
                          >
                            <span>Assessment Note</span>
                            <p>{row?.assessment_mark}</p>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Assessment */}
      <div
        className={
          isToggleChallenge
            ? "assessment-dashboard slide-in"
            : "assessment-dashboard slide-out"
        }
      >
        <div className="assessment-dashboard-wrapper">
          <div className="stage-head w-full">
            <div className="w-fit-content">
              <h1>♻️ Joining an Assessment</h1>
              <p>
                Join an assessment through the code that the host shared with
                you
              </p>
            </div>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"❌ Close"}
              action={() => onToggleChallenge()}
            />
          </div>
          <div className="stage-container">
            {isToggleChallenge && (
              <div className="w-full d-flex justify-center align-center gap-md p-lg">
                <div className="w-60">
                  <InputText
                    name="challenge_code"
                    title="Type the Assessment's Code Here..."
                    value={assessmentCode}
                    onChange={(e) => setAssessmentCode(e.target.value)}
                    disabled={isSending ? true : false}
                  />
                </div>
                {assessmentCode.length === 3 &&
                  (isSending ? (
                    <span style={{ color: "green" }}>Joining...</span>
                  ) : (
                    <div className="fade-in">
                      <Button
                        type={"button"}
                        preferedStyle={"normal"}
                        title={"Ready to join, Go!"}
                        action={() => onHandleJoiningAssessment()}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default StudentDashboard;
